import { render, staticRenderFns } from "./ProItem.vue?vue&type=template&id=52420360&scoped=true"
import script from "./ProItem.vue?vue&type=script&lang=js"
export * from "./ProItem.vue?vue&type=script&lang=js"
import style0 from "./ProItem.vue?vue&type=style&index=0&id=52420360&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52420360",
  null
  
)

export default component.exports